import { Stack } from '@mui/material'
import { ITruckVisitItem } from '@planning/rt-stores/truckVisit/TruckVisitItem'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { OrderWarnings } from '../Atoms/OrderWarnings'

interface Props {
  truckVisit: ITruckVisitItem
  needsReservation?: boolean
}
export const TruckVisitWarnings = observer(({ truckVisit, needsReservation }: Props) => {
  const hasActiveHolds = computed(() => truckVisit.orders.some(order => order.hasActiveHold)).get()

  const allOrdersAreGeneralCargo = computed(() => {
    return (
      truckVisit.orders.length > 0 && truckVisit.orders.every(order => !!order.data.commodityId)
    )
  }).get()

  const doesNotHaveReservation = computed(
    () => needsReservation && truckVisit.inboundOrders.some(o => o.hasMissingPosition),
  ).get()

  const cannotBeFulfilled = computed(() =>
    truckVisit.outboundOrders.some(o => o.isNonNumericAndCannotBeFulfilled),
  ).get()

  return (
    <Stack direction='row' spacing={1}>
      <OrderWarnings
        hasHold={hasActiveHolds}
        hasMissingReservation={doesNotHaveReservation}
        cannotBeFulfilled={cannotBeFulfilled}
        allOrdersAreGeneralCargo={allOrdersAreGeneralCargo}
      />
    </Stack>
  )
})
